import * as e from "zod";
//#region src/apiUrls.ts
var t = "https://address.api.myparcel.nl", n = "https://address.api.acceptance.myparcel.nl", r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var h = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, _ = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, v = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, y = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (v(t, n.name)) continue;
		let e = await h(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, b = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), x = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = C(e.headers, t.headers), n;
}, S = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, C = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? S(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, w = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, T = () => ({
	error: new w(),
	request: new w(),
	response: new w()
}), E = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), D = { "Content-Type": "application/json" }, O = (e = {}) => ({
	...r,
	headers: D,
	parseAs: "auto",
	querySerializer: E,
	...e
}), k = ((e = {}) => {
	let t = x(O(), e), n = () => ({ ...t }), r = (e) => (t = x(t, e), n()), a = T(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: C(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await y({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: b(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? _(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => b({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(O({
	baseUrl: "https://address.api.myparcel.nl",
	throwOnError: !0
})), A = e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }), j = e.enum(/* @__PURE__ */ "AL.AK.AZ.AR.CA.CO.CT.DE.FL.GA.HI.ID.IL.IN.IA.KS.KY.LA.ME.MD.MA.MI.MN.MS.MO.MT.NE.NV.NH.NJ.NM.NY.NC.ND.OH.OK.OR.PA.RI.SC.SD.TN.TX.UT.VT.VA.WA.DC.WV.WI.WY".split(".")), M = e.enum([
	"AB",
	"BC",
	"MB",
	"NB",
	"NL",
	"NS",
	"NT",
	"NU",
	"ON",
	"PE",
	"SK",
	"QC",
	"YT"
]), N = e.union([
	e.object({
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City name." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().min(1).max(100).register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.enum(["BE"]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code." }),
		boxNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "Bus number, only for Belgian addresses." }).optional()
	}),
	e.object({
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City name." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().min(1).max(100).register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code." }).optional()
	}),
	e.object({
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City name." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().min(1).max(100).register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.enum(["NL"]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code." }),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix." }).optional()
	})
]), P = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), F = P.and(e.object({
	type: e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), I = e.object({ valid: e.boolean() }), L = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: A.optional(),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		query: e.string().min(3).max(200).register(e.globalRegistry, { description: "Query string to search for an address. Must be used when `houseNumber` and `postalCode` are not used." }).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "Limit the number of addresses to respond. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional().default(5)
	}).optional()
}), R = e.object({ results: e.array(N).register(e.globalRegistry, { description: "When `countryCode`=`NL` and there is no house number suffix supplied then the result will be all the addresses under that house number, and currently that is under 300. For other countries the result is limited to the default 5 or the specified limit." }) }).register(e.globalRegistry, { description: "Found addresses." }), z = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: A,
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code to validate an address with. The postalCode is only used for validation when the country uses a postal code system, otherwise it is ignored." }).optional(),
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City to validate an address with. For dutch addresses this is not validated." }).optional(),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number to validate an address with. For dutch addresses this is mandatory." }).optional(),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix to validate an address with. For dutch addresses this could be mandatory to identify an apartment." }).optional(),
		boxNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "Bus number to validate an address with, this is only for Belgian addresses (instead of a houseNumberSuffix)" }).optional(),
		region: e.string().min(1).max(100).register(e.globalRegistry, { description: "Region to validate an address with. For dutch addresses this is not validated." }).optional(),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street to validate an address with. For dutch addresses this is not validated." }).optional(),
		validationType: e.enum(["FORMAT"]).register(e.globalRegistry, { description: "When used it only validates the format of the address. Otherwise its existence is also validated." }).optional()
	})
}), B = I, V = e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." });
e.union([e.enum(/* @__PURE__ */ "AL.AK.AZ.AR.CA.CO.CT.DE.FL.GA.HI.ID.IL.IN.IA.KS.KY.LA.ME.MD.MA.MI.MN.MS.MO.MT.NE.NV.NH.NJ.NM.NY.NC.ND.OH.OK.OR.PA.RI.SC.SD.TN.TX.UT.VT.VA.WA.DC.WV.WI.WY".split(".")), e.string()]), e.union([e.enum([
	"AB",
	"BC",
	"MB",
	"NB",
	"NL",
	"NS",
	"NT",
	"NU",
	"ON",
	"PE",
	"SK",
	"QC",
	"YT"
]), e.string()]);
var H = e.union([
	e.object({
		city: e.string().register(e.globalRegistry, { description: "City name." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.union([e.enum(["BE"]), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code." }),
		boxNumber: e.string().register(e.globalRegistry, { description: "Bus number, only for Belgian addresses." }).optional()
	}),
	e.object({
		city: e.string().register(e.globalRegistry, { description: "City name." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code." }).optional()
	}),
	e.object({
		city: e.string().register(e.globalRegistry, { description: "City name." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.union([e.enum(["NL"]), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code." }),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix." }).optional()
	})
]);
e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}).and(e.object({
	type: e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
}));
var U = e.object({ valid: e.boolean() });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: V.optional(),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		query: e.string().register(e.globalRegistry, { description: "Query string to search for an address. Must be used when `houseNumber` and `postalCode` are not used." }).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "Limit the number of addresses to respond. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional().default(5)
	}).optional()
});
var W = e.object({ results: e.array(H).register(e.globalRegistry, { description: "When `countryCode`=`NL` and there is no house number suffix supplied then the result will be all the addresses under that house number, and currently that is under 300. For other countries the result is limited to the default 5 or the specified limit." }) }).register(e.globalRegistry, { description: "Found addresses." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: V,
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code to validate an address with. The postalCode is only used for validation when the country uses a postal code system, otherwise it is ignored." }).optional(),
		city: e.string().register(e.globalRegistry, { description: "City to validate an address with. For dutch addresses this is not validated." }).optional(),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number to validate an address with. For dutch addresses this is mandatory." }).optional(),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix to validate an address with. For dutch addresses this could be mandatory to identify an apartment." }).optional(),
		boxNumber: e.string().register(e.globalRegistry, { description: "Bus number to validate an address with, this is only for Belgian addresses (instead of a houseNumberSuffix)" }).optional(),
		region: e.string().register(e.globalRegistry, { description: "Region to validate an address with. For dutch addresses this is not validated." }).optional(),
		street: e.string().register(e.globalRegistry, { description: "Street to validate an address with. For dutch addresses this is not validated." }).optional(),
		validationType: e.union([e.enum(["FORMAT"]), e.string()]).register(e.globalRegistry, { description: "When used it only validates the format of the address. Otherwise its existence is also validated." }).optional()
	})
});
var G = U, K = (e) => (e?.client ?? k).get({
	requestValidator: async (e) => await L.parseAsync(e),
	responseValidator: async (e) => await W.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/addresses",
	...e
}), q = (e) => (e.client ?? k).get({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await G.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/validate",
	...e
}), J = {
	AD: "AD",
	AE: "AE",
	AF: "AF",
	AG: "AG",
	AI: "AI",
	AL: "AL",
	AM: "AM",
	AO: "AO",
	AQ: "AQ",
	AR: "AR",
	AS: "AS",
	AT: "AT",
	AU: "AU",
	AW: "AW",
	AX: "AX",
	AZ: "AZ",
	BA: "BA",
	BB: "BB",
	BD: "BD",
	BE: "BE",
	BF: "BF",
	BG: "BG",
	BH: "BH",
	BI: "BI",
	BJ: "BJ",
	BL: "BL",
	BM: "BM",
	BN: "BN",
	BO: "BO",
	BQ: "BQ",
	BR: "BR",
	BS: "BS",
	BT: "BT",
	BV: "BV",
	BW: "BW",
	BY: "BY",
	BZ: "BZ",
	CA: "CA",
	CC: "CC",
	CD: "CD",
	CF: "CF",
	CG: "CG",
	CH: "CH",
	CI: "CI",
	CK: "CK",
	CL: "CL",
	CM: "CM",
	CN: "CN",
	CO: "CO",
	CR: "CR",
	CU: "CU",
	CV: "CV",
	CW: "CW",
	CX: "CX",
	CY: "CY",
	CZ: "CZ",
	DE: "DE",
	DJ: "DJ",
	DK: "DK",
	DM: "DM",
	DO: "DO",
	DZ: "DZ",
	EC: "EC",
	EE: "EE",
	EG: "EG",
	EH: "EH",
	ER: "ER",
	ES: "ES",
	ET: "ET",
	FI: "FI",
	FJ: "FJ",
	FK: "FK",
	FM: "FM",
	FO: "FO",
	FR: "FR",
	GA: "GA",
	GB: "GB",
	GD: "GD",
	GE: "GE",
	GF: "GF",
	GG: "GG",
	GH: "GH",
	GI: "GI",
	GL: "GL",
	GM: "GM",
	GN: "GN",
	GP: "GP",
	GQ: "GQ",
	GR: "GR",
	GS: "GS",
	GT: "GT",
	GU: "GU",
	GW: "GW",
	GY: "GY",
	HK: "HK",
	HM: "HM",
	HN: "HN",
	HR: "HR",
	HT: "HT",
	HU: "HU",
	ID: "ID",
	IE: "IE",
	IL: "IL",
	IM: "IM",
	IN: "IN",
	IO: "IO",
	IQ: "IQ",
	IR: "IR",
	IS: "IS",
	IT: "IT",
	JE: "JE",
	JM: "JM",
	JO: "JO",
	JP: "JP",
	KE: "KE",
	KG: "KG",
	KH: "KH",
	KI: "KI",
	KM: "KM",
	KN: "KN",
	KP: "KP",
	KR: "KR",
	KW: "KW",
	KY: "KY",
	KZ: "KZ",
	LA: "LA",
	LB: "LB",
	LC: "LC",
	LI: "LI",
	LK: "LK",
	LR: "LR",
	LS: "LS",
	LT: "LT",
	LU: "LU",
	LV: "LV",
	LY: "LY",
	MA: "MA",
	MC: "MC",
	MD: "MD",
	ME: "ME",
	MF: "MF",
	MG: "MG",
	MH: "MH",
	MK: "MK",
	ML: "ML",
	MM: "MM",
	MN: "MN",
	MO: "MO",
	MP: "MP",
	MQ: "MQ",
	MR: "MR",
	MS: "MS",
	MT: "MT",
	MU: "MU",
	MV: "MV",
	MW: "MW",
	MX: "MX",
	MY: "MY",
	MZ: "MZ",
	NA: "NA",
	NC: "NC",
	NE: "NE",
	NF: "NF",
	NG: "NG",
	NI: "NI",
	NL: "NL",
	NO: "NO",
	NP: "NP",
	NR: "NR",
	NU: "NU",
	NZ: "NZ",
	OM: "OM",
	PA: "PA",
	PE: "PE",
	PF: "PF",
	PG: "PG",
	PH: "PH",
	PK: "PK",
	PL: "PL",
	PM: "PM",
	PN: "PN",
	PR: "PR",
	PS: "PS",
	PT: "PT",
	PW: "PW",
	PY: "PY",
	QA: "QA",
	RE: "RE",
	RO: "RO",
	RS: "RS",
	RU: "RU",
	RW: "RW",
	SA: "SA",
	SB: "SB",
	SC: "SC",
	SD: "SD",
	SE: "SE",
	SG: "SG",
	SH: "SH",
	SI: "SI",
	SJ: "SJ",
	SK: "SK",
	SL: "SL",
	SM: "SM",
	SN: "SN",
	SO: "SO",
	SR: "SR",
	SS: "SS",
	ST: "ST",
	SV: "SV",
	SX: "SX",
	SY: "SY",
	SZ: "SZ",
	TC: "TC",
	TD: "TD",
	TF: "TF",
	TG: "TG",
	TH: "TH",
	TJ: "TJ",
	TK: "TK",
	TL: "TL",
	TM: "TM",
	TN: "TN",
	TO: "TO",
	TR: "TR",
	TT: "TT",
	TV: "TV",
	TW: "TW",
	TZ: "TZ",
	UA: "UA",
	UG: "UG",
	UM: "UM",
	US: "US",
	UY: "UY",
	UZ: "UZ",
	VA: "VA",
	VC: "VC",
	VE: "VE",
	VG: "VG",
	VI: "VI",
	VN: "VN",
	VU: "VU",
	WF: "WF",
	WS: "WS",
	XK: "XK",
	YE: "YE",
	YT: "YT",
	ZA: "ZA",
	ZM: "ZM",
	ZW: "ZW"
}, Y = {
	AL: "AL",
	AK: "AK",
	AZ: "AZ",
	AR: "AR",
	CA: "CA",
	CO: "CO",
	CT: "CT",
	DE: "DE",
	FL: "FL",
	GA: "GA",
	HI: "HI",
	ID: "ID",
	IL: "IL",
	IN: "IN",
	IA: "IA",
	KS: "KS",
	KY: "KY",
	LA: "LA",
	ME: "ME",
	MD: "MD",
	MA: "MA",
	MI: "MI",
	MN: "MN",
	MS: "MS",
	MO: "MO",
	MT: "MT",
	NE: "NE",
	NV: "NV",
	NH: "NH",
	NJ: "NJ",
	NM: "NM",
	NY: "NY",
	NC: "NC",
	ND: "ND",
	OH: "OH",
	OK: "OK",
	OR: "OR",
	PA: "PA",
	RI: "RI",
	SC: "SC",
	SD: "SD",
	TN: "TN",
	TX: "TX",
	UT: "UT",
	VT: "VT",
	VA: "VA",
	WA: "WA",
	DC: "DC",
	WV: "WV",
	WI: "WI",
	WY: "WY"
}, X = {
	AB: "AB",
	BC: "BC",
	MB: "MB",
	NB: "NB",
	NL: "NL",
	NS: "NS",
	NT: "NT",
	NU: "NU",
	ON: "ON",
	PE: "PE",
	SK: "SK",
	QC: "QC",
	YT: "YT"
};
//#endregion
export { k as _, q as a, L as c, B as d, P as f, I as g, j as h, K as i, R as l, M as m, X as n, N as o, F as p, Y as r, A as s, J as t, z as u, n as v, t as y };
